module.exports = __webpack_public_path__ + "img/ar_ara.9e77cde0.png";